/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Creators_Unable_To_ConnectInputs */

const en_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For creators unable to connect Stripe. Payouts processed securely every 2 - 4 weeks.`)
};

const es_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para creadores que no pueden conectar Stripe. Los pagos se procesan de forma segura cada 2 - 4 semanas.`)
};

const fr_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les créateurs ne pouvant pas connecter Stripe. Paiements traités de manière sécurisée toutes les 2 à 4 semaines.`)
};

const de_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Creator, die Stripe nicht verbinden können. Auszahlungen werden alle 2 - 4 Wochen sicher verarbeitet.`)
};

const ja_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripeに接続できないクリエイター向け。支払いは2〜4週間ごとに安全に処理されます。`)
};

const zh_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于无法连接 Stripe 的创作者。提现将安全地每 2-4 周处理一次。`)
};

const ar_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للمبدعين غير القادرين على ربط Stripe. تتم معالجة المدفوعات بأمان كل 2 إلى 4 أسابيع.`)
};

const id_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk kreator yang tidak dapat terhubung ke Stripe. Pembayaran diproses dengan aman setiap 2 - 4 minggu.`)
};

const it_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per i creatori che non possono connettersi a Stripe. I pagamenti vengono elaborati in modo sicuro ogni 2 - 4 settimane.`)
};

const ru_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для авторов, не имеющих возможности подключить Stripe. Выплаты надежно обрабатываются каждые 2 - 4 недели.`)
};

const pt_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para criadores incapazes de conectar o Stripe. Pagamentos processados com segurança a cada 2 - 4 semanas.`)
};

const ko_for_creators_unable_to_connect = /** @type {(inputs: For_Creators_Unable_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe를 연결할 수 없는 크리에이터용. 정산은 2~4주마다 안전하게 처리됩니다.`)
};

/**
* | output |
* | --- |
* | "For creators unable to connect Stripe. Payouts processed securely every 2 - 4 weeks." |
*
* @param {For_Creators_Unable_To_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const for_creators_unable_to_connect = /** @type {((inputs?: For_Creators_Unable_To_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Creators_Unable_To_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_for_creators_unable_to_connect(inputs)
	if (locale === "es") return es_for_creators_unable_to_connect(inputs)
	if (locale === "fr") return fr_for_creators_unable_to_connect(inputs)
	if (locale === "de") return de_for_creators_unable_to_connect(inputs)
	if (locale === "ja") return ja_for_creators_unable_to_connect(inputs)
	if (locale === "zh") return zh_for_creators_unable_to_connect(inputs)
	if (locale === "ar") return ar_for_creators_unable_to_connect(inputs)
	if (locale === "id") return id_for_creators_unable_to_connect(inputs)
	if (locale === "it") return it_for_creators_unable_to_connect(inputs)
	if (locale === "ru") return ru_for_creators_unable_to_connect(inputs)
	if (locale === "pt") return pt_for_creators_unable_to_connect(inputs)
	return ko_for_creators_unable_to_connect(inputs)
});